/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FlowStatePollerQueryVariables = {
    flowStateRelayId: string;
};
export type FlowStatePollerQueryResponse = {
    readonly flowState: {
        readonly " $fragmentRefs": FragmentRefs<"FlowStatePoller_flowState">;
    } | null;
};
export type FlowStatePollerQuery = {
    readonly response: FlowStatePollerQueryResponse;
    readonly variables: FlowStatePollerQueryVariables;
};



/*
query FlowStatePollerQuery(
  $flowStateRelayId: ID!
) {
  flowState: node(id: $flowStateRelayId) {
    __typename
    ... on FlowState {
      ...FlowStatePoller_flowState
    }
    id
  }
}

fragment FlowStatePoller_flowState on FlowState {
  id
  flowKey
  previousState
  current {
    state
    percentComplete
    errorMessage
    id
  }
  pending {
    state
    percentComplete
    errorMessage
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "flowStateRelayId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "flowStateRelayId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any,
        (v2 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "FlowStatePollerQuery",
            "selections": [
                {
                    "alias": "flowState",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "FlowStatePoller_flowState"
                                }
                            ],
                            "type": "FlowState",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "FlowStatePollerQuery",
            "selections": [
                {
                    "alias": "flowState",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        },
                        (v2 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "flowKey",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "previousState",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStatus",
                                    "kind": "LinkedField",
                                    "name": "current",
                                    "plural": false,
                                    "selections": (v3 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FlowStatus",
                                    "kind": "LinkedField",
                                    "name": "pending",
                                    "plural": false,
                                    "selections": (v3 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "type": "FlowState",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "343b9a519f10166d012d9402a4a3b771",
            "id": null,
            "metadata": {},
            "name": "FlowStatePollerQuery",
            "operationKind": "query",
            "text": "query FlowStatePollerQuery(\n  $flowStateRelayId: ID!\n) {\n  flowState: node(id: $flowStateRelayId) {\n    __typename\n    ... on FlowState {\n      ...FlowStatePoller_flowState\n    }\n    id\n  }\n}\n\nfragment FlowStatePoller_flowState on FlowState {\n  id\n  flowKey\n  previousState\n  current {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n  pending {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '69fe30fb95b96b77dd771c9efc4add77';
export default node;
